<div class="header">
    <h2>{{ 'quizzes.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="quizzes-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'quizzes.error.unavailable' | translate" />
} @else if (quiz(); as quiz) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'quizzes.fieldset.basic' | translate }}</h2>
            <app-form-input
                [control]="form.controls.name"
                [label]="'quizzes.form.name' | translate"
                [placeholder]="'quizzes.form.name.placeholder' | translate"
                inputId="name"
                testId="quizzes-edit-name"
            />
        </div>

        <app-quiz-question-list
            [questions]="draftQuestions()"
            [loading]="questionsLoading()"
            testId="quizzes-edit-questions"
            (add)="onAddQuestion()"
            (remove)="onRemoveQuestion($event)"
            (reorder)="reorderQuestions($event)"
        />
    </form>

    <div class="footer">
        <p-button [label]="'quizzes.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="quizzes-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'quizzes.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="quizzes-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
